import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const fetchStatistiques = async params => {
  const stats = await axios.get('/admin/statistiques/fetch', { params })
    .catch((e) => {
      throw new CustomException(e, 'Error fetching statistiques')
    })
  return stats.data
}
